import React, { useState } from 'react';
import Rules from '../components/Rules';
import './Home.css';

export default function Home({ setStage, leaderboard, name, setName }) {
  // Keep track of if user clicks on rules or leaderboard
  const [display, setDisplay] = useState('home');

  // Set error message for name choice
  const [error, setError] = useState('');

  // Make sure name is not empty and advance to game stage
  function validate() {
    // User did not enter a name
    if (!name) {
      setError('Please enter your name to continue.');
      return;
    }
    // Name cannot contain ., #, $, [, ]
    if (!name.match(/^[\w\d\s-]+$/)) {
      setError('Name can only contain letters and numbers.');
      return;
    }
    // User's name choice is already taken
    for (let i in leaderboard) {
      if (leaderboard[i].name === name.trim()) {
        setError('This name is already taken.');
        return;
      }
    }
    // No errors
    setError('');
    // Advance to game
    setStage('game');
  }

  return (
    <div className='home-container'>
      <div className='home-center'>
        {(display === 'home') && <Landing setDisplay={setDisplay} setName={setName} validate={validate} error={error} />}
        {(display === 'rules') && <Rules setDisplay={setDisplay} />}
        {(display === 'leaderboard') && <Leaderboard setDisplay={setDisplay} setName={setName} leaderboard={leaderboard} />}
      </div>
    </div>
  );
}

function Landing({ setDisplay, setName, validate, error }) {
  return (
    <div className='home-content'>
      <h1>
        <strong>
          <span className='black'>493</span><span className='red'>jack</span>
        </strong>
      </h1>
      <h3>
        Welcome to <span className='black'>493</span><span className='red'>jack</span>!
      </h3>

      <div className='enter-name'>
        <input type='text' placeholder='Enter your name' onChange={(e) => setName(e.target.value)}/>
        <button className='next-button' onClick={validate}>
          <i className='fa fa-play'></i>
        </button>
      </div>

      <div>
        {(error) && <h5><span className='red'>{error}</span></h5>}
      </div>

      <div style={{ marginTop: (error) ? 0 : 30 }}>
        <button className='home-rules' onClick={() => setDisplay('rules')}>
          <i className='fa fa-info-circle'></i> Rules
        </button>
        <button className='home-board' onClick={() => setDisplay('leaderboard')}>
          <i className='fa fa-trophy'></i> Leaderboard
        </button>
      </div>
    </div>
  )
}

function Leaderboard({ setDisplay, setName, leaderboard }) {
  return (
    <div className='board-content'>
      <div className='home-title'>
        <button className='next-button' onClick={() => setDisplay('home')}>
          <i className='fa fa-times'></i>
        </button>
        <h1>
          <strong>
            Leaderboard
          </strong>
        </h1>
      </div>

      <div className='rules-scroll'>
        <ol>
          {leaderboard.map(leader =>
            <li>
              {leader.name}<span className='align-right'>${leader.money}</span>
            </li>
          )}
        </ol>
      </div>
    </div>
  )
}
